import React from 'react';
import ReactDOM from 'react-dom/client';
// TS Migration: Root Refresh v2.4.2
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
